export const CountryOptions = [
  {label: "PHILIPPINES",value: "PHILIPPINES"}
  ];
  export const CityOptions = [
  

  { label: 'MATI', value: 'MATI' },
  { label: 'DON SALVADOR BENEDICTO', value: 'DON SALVADOR BENEDICTO' },
  { label: 'SANTA TERESITA', value: 'SANTA TERESITA' },
  { label: 'SANTOL', value: 'SANTOL' },
  { label: 'STO. CRISTO', value: 'STO. CRISTO' },
  { label: 'STO. NIÑO', value: 'STO. NIÑO' },
  { label: 'SAUYO', value: 'SAUYO' },
  { label: 'SIENNA', value: 'SIENNA' },
  { label: 'SIKATUNA VILLAGE', value: 'SIKATUNA VILLAGE' },
  { label: 'SILANGAN', value: 'SILANGAN' },
  { label: 'SOCORRO', value: 'SOCORRO' },
  { label: 'SOUTH TRIANGLE', value: 'SOUTH TRIANGLE' },
  { label: 'TAGUMPAY', value: 'TAGUMPAY' },
  { label: 'TALAMPAS', value: 'TALAMPAS' },
  { label: 'TALAYAN', value: 'TALAYAN' },
  { label: 'TALIPAPA', value: 'TALIPAPA' },
  { label: 'TANDANG SORA', value: 'TANDANG SORA' },
  { label: 'TATALON', value: 'TATALON' },
  { label: 'TEACHERS VILLAGE', value: 'TEACHERS VILLAGE' },
  { label: 'UGONG NORTE', value: 'UGONG NORTE' },
  { label: 'UNANG SIGAW', value: 'UNANG SIGAW' },
  { label: 'U.P.P.O.', value: 'U.P.P.O.' },
  { label: 'U.P. VILLAGE', value: 'U.P. VILLAGE' },
  { label: 'VALENCIA', value: 'VALENCIA' },
  { label: 'VASRA', value: 'VASRA' },
  { label: 'VETERANS VILLAGE', value: 'VETERANS VILLAGE' },
  { label: 'VILLA MARIA CLARA', value: 'VILLA MARIA CLARA' },
  { label: 'VIOLAGO HOMES', value: 'VIOLAGO HOMES' },
  { label: 'WEST TRIANGLE', value: 'WEST TRIANGLE' },
  { label: 'WHITE PLAINS', value: 'WHITE PLAINS' },
  { label: 'BRAULIO E. DUJALI', value: 'BRAULIO E. DUJALI' },
  { label: 'NAUJAN', value: 'NAUJAN' },
  { label: 'TAMPARAN', value: 'TAMPARAN' },
  { label: 'TARAKA', value: 'TARAKA' },
  { label: 'WAO', value: 'WAO' },
  { label: 'AGOO', value: 'AGOO' },
  { label: 'ARINGAY', value: 'ARINGAY' },
  { label: 'BACNOTAN', value: 'BACNOTAN' },
  { label: 'BAGULIN', value: 'BAGULIN' },
  { label: 'BALAOAN', value: 'BALAOAN' },
  { label: 'BANGAR', value: 'BANGAR' },
  { label: 'BAUANG', value: 'BAUANG' },
  { label: 'BURGOS', value: 'BURGOS' },
  { label: 'CABA', value: 'CABA' },
  { label: 'DAMORTIS', value: 'DAMORTIS' },
  { label: 'LUNA', value: 'LUNA' },
  { label: 'NAGUILLAN', value: 'NAGUILLAN' },
  { label: 'PUGO', value: 'PUGO' },
  { label: 'ROSARIO', value: 'ROSARIO' },
  { label: 'SAN FERNANDO', value: 'SAN FERNANDO' },
  { label: 'SAN GABRIEL', value: 'SAN GABRIEL' },
  { label: 'SAN JUAN', value: 'SAN JUAN' },
  { label: 'SANTOL', value: 'SANTOL' },
  { label: 'SANTO TOMAS', value: 'SANTO TOMAS' },
  { label: 'SUDEPEN', value: 'SUDEPEN' },
  { label: 'TUBAO', value: 'TUBAO' },
  { label: 'ABUYOG', value: 'ABUYOG' },
  { label: 'ALANGALANG', value: 'ALANGALANG' },
  { label: 'ALBUERA', value: 'ALBUERA' },
  { label: 'BABATNGON', value: 'BABATNGON' },
  { label: 'BARUGO', value: 'BARUGO' },
  { label: 'BATO', value: 'BATO' },
  { label: 'BAYBAY', value: 'BAYBAY' },
  { label: 'BURAUEN', value: 'BURAUEN' },
  { label: 'CALUBIAN', value: 'CALUBIAN' },
  { label: 'CAPOOCAN', value: 'CAPOOCAN' },
  { label: 'CARIGARA', value: 'CARIGARA' },
  { label: 'DAGAMI', value: 'DAGAMI' },
  { label: 'DULAG', value: 'DULAG' },
  { label: 'HILONGOS', value: 'HILONGOS' },
  { label: 'HINDANG', value: 'HINDANG' },
  { label: 'INOPACAN', value: 'INOPACAN' },
  { label: 'ISABEL', value: 'ISABEL' },
  { label: 'JARO', value: 'JARO' },
  { label: 'JAVIER', value: 'JAVIER' },
  { label: 'JULITA', value: 'JULITA' },
  { label: 'KANANGA', value: 'KANANGA' },
  { label: 'LA PAZ', value: 'LA PAZ' },
  { label: 'LEYTE', value: 'LEYTE' },
  { label: 'GENERAL MAC ARTHUR', value: 'GENERAL MAC ARTHUR' },
  { label: 'MAHAPLAG', value: 'MAHAPLAG' },
  { label: 'MATAG-OB', value: 'MATAG-OB' },
  { label: 'MATALOM', value: 'MATALOM' },
  { label: 'MAYORGA', value: 'MAYORGA' },
  { label: 'PULANG LUPA & ZAPOTE', value: 'PULANG LUPA & ZAPOTE' },
  { label: 'PULANG LUPA', value: 'PULANG LUPA' },
  { label: 'AYALA', value: 'AYALA' },
  { label: 'PASEO DE ROXAS', value: 'PASEO DE ROXAS' },
  { label: 'BANGKAL', value: 'BANGKAL' },
  { label: 'BEL-AIR', value: 'BEL-AIR' },
  { label: 'CEMBO', value: 'CEMBO' },
  { label: 'PANITAN', value: 'PANITAN' },
  { label: 'PILAR', value: 'PILAR' },
  { label: 'PRES. ROXAS', value: 'PRES. ROXAS' },
  { label: 'PUNTEVEDRA', value: 'PUNTEVEDRA' },
  { label: 'ROXAS CITY', value: 'ROXAS CITY' },
  { label: 'SAPIAN', value: 'SAPIAN' },
  { label: 'TAPAZ', value: 'TAPAZ' },
  { label: 'BAGAMANOC', value: 'BAGAMANOC' },
  { label: 'BARAS', value: 'BARAS' },



  ];
  export const ProvinceOptions = [
  
    
      {label:"DAVAO ORIENTAL",value:"DAVAO ORIENTAL"},
      "NEGROS OCCIDENTAL",
      "QUEZON CITY",
      "DAVAO DEL NORTE",
      "ORIENTAL MINDORO",
      "LA UNION",
      "LEYTE",
      "LAS PINAS CITY",
      "MAKATI CITY",
      "CAPIZ",
      "CATANDUANES",
      "ILOCOS SUR",
      "ILOILO",
      "ZAMBOANGA DEL NORTE",
      "ZAMBOANGA DEL SUR",
      "QUEZON PROVINCE",
      "PANGASINAN",
      "BOHOL",
      "CAVITE",
      "DAVAO DE ORO",
      "CEBU",
      "MISAMIS ORIENTAL",
      "BASILAN",
      "QUIRINO PROVINCE",
      "ISABELA",
      "BUKIDNON",
      "MALABON CITY",
      "MANDALUYONG CITY",
      "MOUNTAIN PROVINCE",
      "ABRA",
      "AGUSAN DEL NORTE",
      "AGUSAN DEL SUR",
      "AKLAN",
      "MARIKINA CITY",
      "BULACAN",
      "COTABATO",
      "NEGROS ORIENTAL",
      "LAGUNA",
      "KALINGA",
      "APAYAO",
      "CAGAYAN",
      "SOUTHERN LEYTE",
      "MAGUINDANAO",
      "NUEVA ECIJA",
      "RIZAL PROVINCE",
      "ROMBLON",
      "EASTERN SAMAR",
      "ALBAY",
      "ANTIQUE",
      "AURORA",
      "BATAAN",
      "CAMARINES NORTE",
      "CAMARINES SUR",
      "NUEVA VIZCAYA",
      "PALAWAN",
      "NORTHERN SAMAR",
      "SAMAR",
      "LANAO DEL NORTE",
      "CITY OF MANILA",
      "CALOOCAN CITY",
      "MARINDUQUE",
      "MASBATE",
      "OCCIDENTAL MINDORO",
      "MUNTINLUPA CITY",
      "SAN JUAN CITY",
      "SARANGANI",
      "SIQUIJOR",
      "SORSOGON",
      "SULTAN KUDARAT",
      "BATANES",
      "BATANGAS",
      "PAMPANGA",
      "NAVOTAS CITY",
      "PARANAQUE CITY",
      "MISAMIS OCCIDENTAL",
      "TAGUIG CITY",
      "SOUTH COTABATO",
      "DAVAO DEL SUR",
      "DAVAO OCCIDENTAL",
      "SULU PROVINCE",
      "SURIGAO DEL NORTE",
      "DINAGAT ISLANDS",
      "SURIGAO DEL SUR",
      "BENGUET",
      "BILIRAN",
      "PASAY CITY",
      "VALENZUELA CITY",
      "TARLAC",
      "TAWI-TAWI",
      "ZAMBALES",
      "PASIG CITY",
      "PATEROS CITY",
      "CAMIGUIN",
      "GUIMARAS",
      "IFUGAO",
      "ILOCOS NORTE"
  
  

  
  ];

  export const TNVSOptions = [
    { label: "True", value: "True" },
    { label: "False", value: "False" },
  ];
  
  export const MortgageOptions = [
    { label: "FEDERAL LAND", value: "FEDERAL LAND" },
    { label: "METROPOLITAN BANK & TRUST CO.", value: "METROPOLITAN BANK & TRUST CO." },
    { label: "OMNI BANK", value: "OMNI BANK" },
    { label: "PHILAM SAVINGS BANK", value: "PHILAM SAVINGS BANK" },
    { label: "BANCO DE ORO UNIBANK, INC.", value: "BANCO DE ORO UNIBANK, INC." },
  ]; 


  export const VehicleBrandOptions = [
    { label: "Toyota", value: "Toyota" },
    { label: "Honda", value: "Honda" },
    { label: "Ford", value: "Ford" },
    { label: "Chevrolet", value: "Chevrolet" },
    { label: "Nissan", value: "Nissan" },
  ];

  export const ModelYearOptions = [
    { label: "2022", value: "2022" },
    { label: "2021", value: "2021" },
    { label: "2020", value: "2020" },
    { label: "2019", value: "2019" },
  ];

  export const ModelVariantOptions = [
    { label: "Sedan", value: "Sedan" },
    { label: "Hatchback", value: "Hatchback" },
    { label: "SUV", value: "SUV" },
    { label: "Coupe", value: "Coupe" },
  ];

  export const VehicleModelOptions = [
    { label: "Camry", value: "Camry" },
    { label: "Civic", value: "Civic" },
    { label: "F-150", value: "F-150" },
    { label: "Malibu", value: "Malibu" },
  ];

  export const VehicleColorOptions = [
    { label: "Red", value: "Red" },
    { label: "Blue", value: "Blue" },
    { label: "Black", value: "Black" },
    { label: "White", value: "White" },
  ];

  export const ActsofnatureRateOptions = [
    { label: "100,000", value: "100,000" },
    { label: "200,000", value: "200,000" },
    { label: "300,000", value: "300,000" },
    { label: "400,000", value: "400,000" },
  ];


  export const BodilyInjuryOptions = [
    { label: "10,000", value: "10,000" },
    { label: "20,000", value: "20,000" },
    { label: "30,000", value: "30,000" },
    { label: "40,000", value: "40,000" },
  ];
  

  export const PropertyDamageOptions = [
    { label: "1000", value: "1000" },
    { label: "2000", value: "2000" },
    { label: "3000", value: "3000" },
    { label: "4000", value: "4000" },
  ];
  

  export const AutopassengerpersonalAccidentOptions = [
    { label: "1000", value: "1000" },
    { label: "2000", value: "2000" },
    { label: "3000", value: "3000" },
    { label: "4000", value: "4000" },
  ];

  export const APPATotalCoverageOptions = [
    { label: "1000", value: "1000" },
    { label: "2000", value: "2000" },
    { label: "3000", value: "3000" },
    { label: "4000", value: "4000" },
  ];


  export const LossandDamagecoverageRateOptions = [
    { label: "1000", value: "1000" },
    { label: "2000", value: "2000" },
    { label: "3000", value: "3000" },
    { label: "4000", value: "4000" },
  ];
  